import { Dom, Tag, Type } from 'main.core';
import { Button } from 'ui.buttons';
import { Popup } from 'main.popup';
import './style.css';

export default class MigrationBar
{
	constructor({target, title, items, buttons, link, hint, wrapperWidth, wrapperHeight, containerWidth, containerHeight})
	{
		this.target = Type.isDomNode(target) ? target : null;
		this.title = Type.isString(title) ? title : null;
		this.items = Type.isArray(items) ? items : [];
		this.buttons = Type.isArray(buttons) ? buttons : null;
		this.link = Type.isObject(link) ? link : null;
		this.hint = Type.isString(hint) ? hint : null;
		this.wrapperWidth = Type.isNumber(wrapperWidth) ? wrapperWidth : null;
		this.wrapperHeight = Type.isNumber(wrapperHeight) ? wrapperHeight : null;
		this.containerWidth = Type.isNumber(containerWidth) ? containerWidth : null;
		this.containerHeight = Type.isNumber(containerHeight) ? containerHeight : null;

		this.layout = {
			wrapper: null,
			container: null,
			title: null,
			text: null
		}

		this.wrapper = null;
		this.container = null;
		this.titleContainer = null;
		this.titleText = null;
		this.cross = null;
		this.itemContainer = null;
		this.buttonsContainer = null;
		this.itemNode = null;
		this.linkNode = null;
		this.hintWindow = null;
		this.hintNode = null;

		this.linkShown = true;
	}

	getWrapper()
	{
		if (!this.wrapper)
		{
			this.wrapper = Tag.render`
				<div class="ui-migration-bar__wrap"></div>
			`;
		}

		return this.wrapper;
	}

	getContainer()
	{
		if (!this.container)
		{
			this.container = Tag.render`
				<div class="ui-migration-bar__container ui-migration-window__scope">
					${this.getCross()}
					${this.title ? this.getTitle() : ''}
					${this.getItemContainer()}
					${this.getButtonsContainer()}
				</div>	
			`;
		}

		return this.container;
	}

	getTitle()
	{
		if (!this.titleContainer)
		{
			this.titleContainer = Tag.render`
				<div class="ui-migration-bar__title">
					<div class="ui-migration-bar__title-name">${this.title}</div>
				</div>
			`;
		}

		return this.titleContainer;
	}

	getTitleText()
	{
		if (!this.titleText)
		{
			this.titleText = Tag.render`
				<div class="ui-migration-bar__title-name">${this.title}</div>
			`;
		}

		return this.titleText;
	}

	getCross()
	{
		if (!this.cross)
		{
			this.cross = Tag.render`
				<div class="ui-migration-bar__cross">
					<div class="ui-migration-bar__cross-icon"></div>
				</div>
			`;
		}

		return this.cross;
	}

	getButtonsContainer()
	{
		if (!this.buttonsContainer)
		{
			this.buttonsContainer = Tag.render`
				<div class="ui-migration-bar__btn-container"></div>
			`;
		}

		return this.buttonsContainer;
	}

	getItemContainer()
	{
		if (!this.itemContainer)
		{
			this.itemContainer = Tag.render`
				<div class="ui-migration-bar__item-container"></div>
			`;
		}

		return this.itemContainer;
	}

	getImage()
	{
		return this.items;
	}

	getLink()
	{
		if (!this.linkNode)
		{
			this.linkNode = Tag.render`
				<a class="ui-migration-bar__link">${this.link ? this.link.text : ''}</a>
			`;
		}

		return this.linkNode;
	}

	getHintIcon()
	{
		if (!this.hintNode)
		{
			this.hintNode = Tag.render`
				<div class="ui-migration-bar__hint-icon"></div>
			`;
		}

		return this.hintNode;
	}

	adjustHint()
	{
		if (this.hint)
		{
			Dom.append(this.getHintIcon(), this.getTitleText());
			this.hintWindow = new Popup('ui-migration-window-hint', this.getHintIcon(), {
				content: this.hint,
				lightShadow: true,
				autoHide: true,
				closeByEsc : true,
				darkMode: true,
				offsetLeft: this.getHintIcon().offsetWidth / 2,
				angle: {
					postion: 'top'
				},
			});
		}
	}

	adjustItemData()
	{
		this.items = this.items.map((item) => {
			return {
				id: item.id ? item.id : null,
				src: item.src ? item.src : null,
				events: item.events ? item.events : null,
			}
		})
	}

	adjustButton()
	{
		if (this.buttons !== [])
		{
			this.buttons.forEach(button => {
				button = new Button({
					id: button.id,
					color: button.color ?  Button.Color[button.color] : Button.Color.PRIMARY,
					size: button.size ? Button.Size[button.size] : Button.Size.MEDIUM,
					round: button.round ? button.round : false,
					text: button.title,
					events: button.events,
				});
				this.getButtonsContainer().appendChild(button.render());
			})
		}
	}

	setEvents()
	{
		this.getCross().addEventListener('click', () => {
			this.getWrapper().style.display = 'none';
			this.getWrapper().remove();
		});

		if (this.hint)
		{
			this.getHintIcon().addEventListener('mouseover', () => {
				this.hintWindow.show();
			})
		}

		if (this.link)
		{
			this.linkNode.setAttribute('href', this.link.href);
			this.linkNode.setAttribute('target', this.link.target);
			this.linkNode.addEventListener('click', () => {
				this.link.target.event.click();
			})
		}
	}

	render()
	{
		if (this.target)
		{
			this.target.appendChild(this.getWrapper());
			this.getWrapper().appendChild(this.getContainer());

			if (this.hint)
			{
				this.adjustHint();
			}

			if (this.wrapperWidth)
			{
				this.getWrapper().style.minWidth = this.wrapperWidth + 'px';
			}
			if (this.wrapperHeight)
			{
				this.getWrapper().style.minHeight = this.wrapperHeight + 'px';
			}
			if (this.containerWidth)
			{
				this.getContainer().style.minWidth = this.containerWidth + 'px';
			}
			if (this.containerHeight)
			{
				this.getContainer().style.minHeight = this.containerHeight + 'px';
			}
		}

		if (this.items !== [])
		{
			this.items.forEach(item => {
				let itemNode = item;
				itemNode = Tag.render`
				<img class="ui-migration-bar__item">
			`;

				this.getItemContainer().appendChild(itemNode);

				const itemKeys = Object.keys(item);
				for (let i = 0; i < itemKeys.length; i++)
				{
					const event = itemKeys[i];
					itemNode.setAttribute(event, item[event]);
				}
			})
		}

		if (this.link)
		{
			Dom.append(this.getLink(), this.getItemContainer());
		}
	}

	init()
	{
		this.adjustItemData();
		this.adjustButton();
		this.render();
		this.setEvents();
	}
}
